
<ng-template #goodTillTooltipContent>
  <div class="info-text fs-12">
    Quote Good Till must be 5 seconds less than the RFQ Expiry Date
    i.e. {{auctionDetails.auction_expiry | StringToDateFormatPipe: null : 'full'}}
  </div>
</ng-template>
<div class="mt-6 mb-6 mx-0 px-2 dark-bg-info-card highlight-border-box">
  <form autocomplete="off" class="form-section" [formGroup]="bidFormGroup">
    <div class="row p-0 m-0">
      <div class="col-4">
        <div class="compt-input" formGroupName="amount">
          <label for="amount">Value Of Quote</label>
          <div class="r-value-box">
            <span class="icons-rs">&#8377;</span>
            <input type="number" [attr.value]="bidFormGroup.get('amount').get('amount').value" class="form-control"
              id="bid-amount" formControlName="amount" min="0">
            <select class="form-control select-box" [attr.value]="bidFormGroup.get('amount').get('amountIn').value"
              id="bid-amount-in" formControlName="amountIn">
              <option>Cr</option>
              <option>Lakhs</option>
            </select>
          </div>
          <div class="error-text" *ngIf="!bidFormGroup.controls['amount'].pristine
            && bidFormGroup.controls['amount'].errors">
            <small [hidden]="!bidFormGroup.controls['amount'].errors.notPositive">
              Amount should be positive.
            </small>
            <small [hidden]="!bidFormGroup.controls['amount'].errors.required">
              Amount is required.
            </small>
            <small [hidden]="!bidFormGroup.controls['amount'].errors.notMultiple5L">
              Amount should be a multiple of 5 Lakhs.
            </small>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="compt-input">
          <label for="roi">Rate</label>
          <div class="r-value-box">
            <input [attr.value]="bidFormGroup.get('roi').value" type="number" class="form-control input-2" id="bid-roi"
              formControlName="roi" min="0">
            <span class="addMid">%</span>
          </div>
          <div class="error-text" *ngIf="!bidFormGroup.controls['roi'].pristine
            && bidFormGroup.controls['roi'].errors">
            <small [hidden]="!bidFormGroup.controls['roi'].errors.min">
              Rate must be more than 0.
            </small>
            <small [hidden]="!bidFormGroup.controls['roi'].errors.required">
              Rate is required.
            </small>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="compt-input">
          <label for="value-date">Value Date</label>
          <div class="r-value-box">
            <input class="form-control for-small-box" [attr.value]="bidFormGroup.get('value_date').value | json"
              [minDate]="today" [maxDate]="valueDateMax" placeholder="dd/mm/yyyy" name="bidsubmit1" id="bid-value-date"
              formControlName="value_date" ngbDatepicker #bidsubmit1="ngbDatepicker"
              [markDisabled]="isWeekendAndHolidayDisabled" [readonly]="true" (click)="bidsubmit1.toggle()">
            <div class="input-group-append icons-calender">
              <button id="bid-value-date" class="btn" (click)="bidsubmit1.toggle()" type="button">
                <i class="far-i fa fa-calendar"></i>
              </button>
            </div>
          </div>
          <div class="error-text" *ngIf="bidFormGroup.controls['value_date'].errors">
            <small [hidden]="!bidFormGroup.controls['value_date'].errors.required">
              Value Date is required.
            </small>
            <small [hidden]="!bidFormGroup.controls['value_date'].errors.maxDaysFromToday">
              Value Date must be within 14 days from today.
            </small>
            <small [hidden]="!bidFormGroup.controls['value_date'].errors.ngbDate">
              {{
              bidFormGroup.controls['value_date'].errors.ngbDate.requiredBefore ?
              'Value Date cannot be a past date.': 'Value Date is required.'
              }}
            </small>
          </div>
          <!-- <small *ngIf="!bidFormGroup.controls['value_date'].errors && valueDateDiffDays">
            {{valueDateDiffDays}}
          </small> -->
        </div>
      </div>
      <div class="col-4">
        <div class="compt-input">
          <label>Issue Duration</label>
          <div class="r-value-box">
            <input [attr.value]="bidFormGroup.get('tenure').value" id="bid-tenure" type="number" step="1"
              min={{minTenure}} max={{maxTenure}} class="form-control" formControlName="tenure">
            <span class="addMidSmall">Days</span>
          </div>
          <div class="info-text" *ngIf="auctionDetails.maturity_date_frozen">
            <small>
              Maturity date cannot be changed.
            </small>
          </div>
          <div class="error-text" *ngIf="bidFormGroup.errors && bidFormGroup.errors.tenure && 
          bidFormGroup.errors.tenure.holidayOrWeekend">
            <small>
              Tenure cannot be a holiday or a Mumbai Business Holiday.
            </small>
          </div>
          <div class="error-text" *ngIf="!bidFormGroup.controls['tenure'].pristine
                  && bidFormGroup.controls['tenure'].errors">
            <small [hidden]="!bidFormGroup.controls['tenure'].errors.min">
              Tenure must be more than {{minTenure}} days.
            </small>
            <small [hidden]="!bidFormGroup.controls['tenure'].errors.max">
              Tenure must be less than {{maxTenure}} days.
            </small>
            <small [hidden]="!bidFormGroup.controls['tenure'].errors.required">
              Tenure is required.
            </small>
          </div>
          <!-- <small *ngIf="!bidFormGroup.controls['tenure'].errors">
                      Maturity Date: {{tenureDate}}
                  </small> -->
        </div>
      </div>
      <div class="col-8">
        <div class="compt-input">
          <label for="value-date">Quote Good Till
            <i class="rel ml-2 fs-15 fa fa-info-circle info-text align-middle" placement="top"
            [ngbTooltip]="goodTillTooltipContent" tooltipClass="cp-ngb-tooltip">
          </i>
          </label>
          <div class="date-time-box">
            <div class="row">
              <div class="col-5">
                <input [attr.value]="bidFormGroup.get('expiryDate').value | json" id="bid-expiry-date"
                  class="form-control date-input" [minDate]="today" name="expiryDate" formControlName="expiryDate"
                  ngbDatepicker placeholder="mm/dd/yyyy" [markDisabled]="isWeekendAndHolidayDisabled" [readonly]="true"
                  #expiryDate="ngbDatepicker" (click)="expiryDate.toggle()">
                <i id="expiry-calendar-btn" (click)="expiryDate.toggle()"
                  class="calendar-icon far-i fa fa-calendar"></i>
              </div>
              <div class="spacer"></div>
              <div class="col-6">
                <ngb-timepicker [attr.value]="bidFormGroup.get('expiryTime').value | json" [meridian]="true"
                  [seconds]="true" id="expiry-time" name="expiryTime" formControlName="expiryTime" 
                  [hourStep]="1" [minuteStep]="15" [secondStep]="1"
                  [spinners]="false"></ngb-timepicker>
              </div>
            </div>
          </div>
          <div class="mx-3 mt-1 d-flex justify-content-between">
            <div class="error-text fs-12" *ngIf="bidFormGroup.errors && bidFormGroup.errors.bidExpiry && 
            bidFormGroup.errors.bidExpiry.moreThanAuctionExpiry">
              <small>
                Quote Expiry must be more than 5 seconds before RFQ expiry {{auctionDetails.auction_expiry | StringToDateFormatPipe: null: 'full_seconds'}}
              </small>
            </div>
            <div class="error-text text-left" *ngIf="bidFormGroup.controls['expiryDate'].errors">
              <small [hidden]="!bidFormGroup.controls['expiryDate'].errors.required">
                Quote Good Till Date is required.
              </small>
            </div>
            <div class="error-text text-right" *ngIf="bidFormGroup.controls['expiryTime'].errors">
              <small [hidden]="!bidFormGroup.controls['expiryTime'].errors.required">
                Quote Good Till Time is required.
              </small>
            </div>
          </div>

        </div>
      </div>
      <div class="col-4">
        <div *ngIf="isInvestor" class="compt-input">
          <label>Check before closing</label>
          <div class="panal-check">
            <div class="form-check has-success">
              <input type="checkbox" formControlName="is_cbc" class="form-check-input" id="bid-enable-cbc"
                [attr.value]="bidFormGroup.get('is_cbc').value">
              <label class="form-check-label" for="bid-enable-cbc">
                Enable CBC
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
      </div>
      <div class="col-6 mt-4">
        <button type="submit" [attr.disabled]="!bidFormGroup.valid  ? true : null" 
        (click)="handleBidAction(bidFormGroup.value)" class="w-100 btn bottom-button"
          [ngClass]=" 'btn-outline-' + actionConfigMap[formAction].btnColorMod"
          id="bid-side-panel-form-{{formAction}}">{{actionConfigMap[formAction].btnText}}</button>
        <div class="ml-4 mt-3 text-left fs-12 warning-text" *ngIf="!bidFormGroup.valid">
          Please Correct the Validation Errors to proceed.
        </div>
      </div>
    </div>
  </form>

</div>